import MhvAlertConfirmEmail from './MhvAlertConfirmEmail';
import ProfileAlertConfirmEmail from './ProfileAlertConfirmEmail';

export default MhvAlertConfirmEmail;
export { ProfileAlertConfirmEmail };
